export class S1ProcessID {
    processID : number;
    versionID : number;
}